<template>
  <div v-if="path" class="img_explain flex-col" @click="showImg(path)">
    <VanImage height="4.266667rem" fit="cover" :src="path" />
    <div class="preview">点击可查看全图</div>
  </div>
</template>
<script>
import { Image } from 'vant'
export default {
  components: {
    VanImage: Image
  },
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    showImg(imgpath) {
      window.wx.previewImage({
        current: 'imgpath', // 当前显示图片的http链接
        urls: [imgpath] // 需要预览的图片http链接列表
      })
    }
  }
}
</script>
<style lang="scss">
.img_explain {
  position: relative;
  img {
    width: 100%;
  }
  .preview {
    position: absolute;
    padding: 2px 4px;
    bottom: 10px;
    right: 18px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 23px;
    font-size: 9px !important;
    color: #ffffff;
  }
}
</style>
